// template for the ReportSecurityEvent table 'serial' column
export default function(h, row) {
   return <a href={'#/soc/serial/' + row.serial }>{row.serial.substring(0,8)}</a>
}



// WEBPACK FOOTER //
// ./src/templates/serialLink.jsx